import React from 'react';

// "Do not text" / "Do not email" flags from COMS's suppression table (HubSpot opt-outs, STOP replies, manual
// do-not-contact). Shown on cards so staff see it before reaching out. Renders nothing for a clean contact.
// Proposal: docs/COMS_SMS_Consent_And_Suppression_Proposal.md (Phase 1).
const style = {
  display: 'inline-block', fontSize: 10, fontWeight: 700, padding: '1px 6px', borderRadius: 4,
  background: 'rgba(239,68,68,0.15)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.35)', marginRight: 4,
};

export default function SuppressionBadges({ doNotText, doNotEmail, style: extra }) {
  if (!doNotText && !doNotEmail) return null;
  return (
    <div style={{ marginTop: 4, ...extra }}>
      {doNotText && <span style={style} title="This person opted out of text messages. Do not text them.">🚫 Do not text</span>}
      {doNotEmail && <span style={style} title="This person unsubscribed from email. Do not email them.">🚫 Do not email</span>}
    </div>
  );
}
